import { createTheme } from "@stitches/react";

import { ITenantDetails } from "../@types/Login";
import { AUTH_TENANT_DETAILS } from "../constants/localStorageKeys";
import { colors } from "../styles/colors";
import { safeStorage } from "./storage";

export type ColorPatch = Partial<Record<keyof typeof colors, string>>;

let currentThemeClass: string | null = null;
const themeName = "tenantTheme";

export function applyColorsPatch(patch: ColorPatch, themeName: string) {
  const updatedColors = { ...colors };
  Object.entries(patch).forEach(([key, value]) => {
    if (
      Object.prototype.hasOwnProperty.call(updatedColors, key) &&
      typeof value === "string"
    ) {
      (updatedColors as any)[key] = value.trim();
    }
  });

  const patchClass = createTheme(themeName, { colors: updatedColors });

  const html = document.documentElement;
  if (currentThemeClass) html.classList.remove(currentThemeClass);
  html.classList.add(patchClass);
  currentThemeClass = patchClass;
}

export function rehydrateColorsPatchPortal() {
  const raw = safeStorage.getItem(AUTH_TENANT_DETAILS);
  if (!raw) return;

  const tenantDetails = JSON.parse(raw) as ITenantDetails;
  if (
    tenantDetails.tenantStyles &&
    typeof tenantDetails.tenantStyles === "string"
  ) {
    let styles: any;
    try {
      styles = JSON.parse(tenantDetails.tenantStyles);
      applyColorsPatch(styles, themeName);
    } catch {
      console.error("Invalid tenantStyles JSON - using default theme");
    }
  }
}

export function rehydrateColorsPatchMobile(styles: string) {
  try {
    const parsedStyles = JSON.parse(styles);
    applyColorsPatch(parsedStyles, themeName);
  } catch {
    console.error("Invalid tenantStyles JSON - using default theme");
  }
}
